import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
export function BonusesSection() {
  const bonuses = [{
    id: 1,
    title: 'La Lista CERO-ERROR del Mercado + Identificador Visual',
    subtitle: 'Para que no pierdas tiempo ni dinero comprando la planta equivocada.',
    value: '$22 USD',
    image: 'https://cdn.magicpatterns.com/uploads/38AmWN3WbrMERb1LuQMkqA/B-1.png',
    bullets: ['Checklist visual de las 7 plantas con foto real de referencia', 'Nombres en español, náhuatl y nombre científico', 'Qué pedir exactamente en Sonora (pasillo 5) y Corabastos', '3 señales de frescura vs. planta vieja', 'Precio justo por planta para no pagar de más']
  }, {
    id: 2,
    title: 'Ritual 10 Min: Guión Nocturno Anti-Desvelo (Sin Fuerza de Voluntad)',
    subtitle: 'El paso a paso para apagar tu día en 10 minutos — sin meditar, sin apps, sin esfuerzo.',
    value: '$22 USD',
    image: 'https://cdn.magicpatterns.com/uploads/gFTqPac1mkNa12viAyxjKD/B-2.png',
    bullets: ['Secuencia de 6 pasos físicos que bajan el cortisol antes de la cama', 'Guión de respiración 4-7-8 adaptado para ansiedad laboral', 'Checklist "apagado digital" para cortar estímulos sin fuerza de voluntad', 'Variante express de 5 minutos para noches de emergencia', 'Audio complementario para seguir el ritual sin leer']
  }, {
    id: 3,
    title: 'Tracker Sueño 7 Noches + Calculadora de Progreso (Plantilla Lista)',
    subtitle: 'La herramienta para saber — con datos reales — que el ciclo te está funcionando.',
    value: '$22 USD',
    image: 'https://cdn.magicpatterns.com/uploads/erQYPb3ABpV7hbzSbzSQnh/B-3.png',
    problemIntro: true,
    bullets: ['Tracker de 7 noches listo para imprimir o usar en el celular', 'Las 5 variables que realmente importan (sin obsesionarte con apps)', 'El Score Semanal — una fórmula simple para ver tendencia en 30 segundos', 'Checklist de 7 errores comunes si no ves cambios en 3 noches', 'Ejemplo rellenado para copiar el estándar "semana exitosa"']
  }];
  return <section className="py-12 md:py-20 px-4 bg-forest-900 overflow-hidden" data-id="element-2">
      <div className="max-w-5xl mx-auto space-y-12 md:space-y-24" data-id="element-3">
        {bonuses.map((bonus, index) => <motion.div key={bonus.id} initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className={`flex flex-col ${index % 2 === 1 ? 'md:flex-row-reverse' : 'md:flex-row'} gap-8 md:gap-12 items-center bg-forest-800 rounded-3xl p-6 md:p-10 border border-gold-500/30 shadow-2xl`} data-id="element-4">
            {/* Image Side */}
            <div className="w-full md:w-1/2" data-id="element-5">
              <div className="relative rounded-2xl overflow-hidden shadow-xl border border-forest-600" data-id="element-6">
                <img src={bonus.image} alt={bonus.title} className="w-full h-auto object-cover" data-id="element-7" />
                <div className="absolute inset-0 bg-gradient-to-t from-forest-900/40 to-transparent pointer-events-none" data-id="element-8" />
              </div>
            </div>

            {/* Content Side */}
            <div className="w-full md:w-1/2 space-y-6" data-id="element-9">
              <div className="inline-block bg-gold-500 text-forest-900 font-bold text-sm px-3 py-1 rounded-full uppercase tracking-wider" data-id="element-10">
                BONO #{bonus.id} — VALOR {bonus.value}
              </div>

              <div data-id="element-11">
                <h3 className="text-2xl md:text-3xl font-serif font-bold text-cream-100 mb-3 leading-tight" data-id="element-12">
                  {bonus.title}
                </h3>
                <p className="text-lg text-gold-400 font-medium italic" data-id="element-13">
                  "{bonus.subtitle}"
                </p>
              </div>

              {bonus.problemIntro && <div className="bg-forest-900/50 p-4 rounded-xl border border-forest-700 space-y-3 text-sm text-cream-200" data-id="element-14">
                  <p data-id="element-15">
                    Aquí está el problema con la mayoría de los métodos
                    naturales:
                  </p>
                  <p data-id="element-16">
                    No sabés si está funcionando hasta que ya abandonaste. Una
                    noche mala al día 3 y pensás "esto no sirve".
                  </p>
                  <p data-id="element-17">Pero si hubieras mirado los datos... habrías visto que:</p>
                  <ul className="list-disc pl-5 space-y-1 text-cream-100 font-medium" data-id="element-18">
                    <li data-id="element-19">Los despertares bajaron de 4 a 1.</li>
                    <li data-id="element-20">Las horas subieron 1.5 en solo 5 noches.</li>
                    <li data-id="element-21">Tu energía AM pasó de 3/10 a 6/10.</li>
                  </ul>
                  <p className="font-bold text-gold-400 pt-2" data-id="element-22">
                    Eso no se siente. Se mide.
                  </p>
                  <p data-id="element-23">Este bono te da:</p>
                </div>}

              <ul className="space-y-3" data-id="element-24">
                {bonus.bullets.map((bullet, i) => <li key={i} className="flex items-start gap-3" data-id="element-25">
                    <div className="mt-1 bg-green-500/20 rounded-full p-0.5 shrink-0" data-id="element-26">
                      <Check className="w-4 h-4 text-green-500" data-id="element-27" />
                    </div>
                    <span className="text-cream-200 leading-relaxed" data-id="element-28">
                      {bullet}
                    </span>
                  </li>)}
              </ul>

              <div className="pt-4 border-t border-forest-600" data-id="element-29">
                <p className="text-lg" data-id="element-30">
                  <span className="text-cream-300 line-through mr-2" data-id="element-31">
                    Valor real: {bonus.value}
                  </span>
                  <span className="text-green-400 font-bold" data-id="element-32">
                    Hoy: GRATIS con tu compra
                  </span>
                </p>
              </div>
            </div>
          </motion.div>)}
      </div>
    </section>;
}